import { CurrencyPipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { KENDO_LISTVIEW } from '@progress/kendo-angular-listview';
import { AbstractGridComponent } from '@unity/abstract/abstract-grid.component';
import { DisbursementDetailedDto, DisbursementsClient } from '@unity/clients';
import { TypedDirective } from '@unity/directives/typed.directive';
import { DateTimezonePipe } from '@unity/pipes/date-timezone.pipe';
import { GridSharedComponent } from '@unity/shared/composed/grid-shared/grid-shared.component';
import { ChipWorkflowStateSharedComponent } from '@unity/shared/presentation/chip-workflow-state-shared/chip-workflow-state-shared.component';
import { LinkGridcellSharedComponent } from '@unity/shared/presentation/link-gridcell-shared/link-gridcell-shared.component';
import { SortConfig } from '@unity/utils/types';

@Component({
  selector: 'unity-grid-disbursement-shared',
  imports: [
    KENDO_GRID,
    KENDO_LISTVIEW,
    KENDO_BUTTON,
    CurrencyPipe,
    DateTimezonePipe,
    ChipWorkflowStateSharedComponent,
    LinkGridcellSharedComponent,
    GridSharedComponent,
    TypedDirective,
  ],
  templateUrl: './grid-disbursement-shared.component.html',
  styleUrl: './grid-disbursement-shared.component.scss',
})
export class GridDisbursementSharedComponent extends AbstractGridComponent<DisbursementDetailedDto> {
  private readonly disbursementsClient = inject(DisbursementsClient);

  protected override readonly resource = rxResource({
    params: () => {
      const query = this.$gridifyQuery();
      const agreementId = this.$agreementId();
      return query && agreementId ? { query, agreementId } : undefined;
    },
    stream: ({ params: { agreementId, query } }) =>
      this.disbursementsClient.getAllForAgreementAsDetailed(agreementId, query.page, query.pageSize, query.orderBy, query.filter),
  });

  protected defaultSort: SortConfig[] = [
    {
      field: 'created_dt',
      dir: 'desc',
    },
  ];

  public readonly $agreementId = input.required<number>({ alias: 'agreementId' });
}
